import { useState } from 'react'
import styled from 'styled-components'
import Instances from './components/Instances/Instances'
import Licenses from './components/Licenses/Licenses'
import MessageBanner from '../../../common/banner/MessageBanner'
import { noop } from '@panwds/react-ui'
import ScreenLoader from '../../../common/components/screenLoader/ScreenLoader'

const Container = styled.div`
  label {
    margin: 0;
  }
`
const EnterpriseActivation = ({
  licenses,
  licenseDispatch,
  licenseContext,
  licenseHash,
  apps,
  globalDispatch,
  licenseInstances,
  userInstances,
  isPanoramaLocked,
  primaryLicense,
  tenants,
  globalTsgId,
  setPanorama,
  ...rest
}) => {
  const [loading] = useState(false)
  const [error, setError] = useState(null)
  const [warning, setWarning] = useState(null)
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       setLoading(true)
  //       await LoadUserInstances(tenants.map(({ id }) => id).filter(id => id !== ROOT_NODE_ID), licenseDispatch)
  //     }
  //     catch (e) {
  //       setError(e.message)
  //     }
  //     setLoading(false)
  //   })()
  // }, [tenants, licenseDispatch])
  return (
    <Container>
      {loading && <ScreenLoader />}
      {error && (<MessageBanner message={error} />)}
      {warning && (<MessageBanner message={warning} donNotCloseBanner={true} bannerProps={{ appearance: 'warning' }} />)}

      <div style={{ maxWidth: '1248px' }}>
        <Licenses
          license={primaryLicense}
          licenses={licenses[0]?.licenses}
          setPanorama={setPanorama}
          {...{
            licenseDispatch,
            licenseContext,
            licenseHash,
            apps,
            globalDispatch,
            licenseInstances,
            setError,
            setWarning,
            isPanoramaLocked,
            tenants,
            globalTsgId,
            ...rest,
          }} />
        <Instances {...{ licenseInstances, licenseDispatch, licenseContext, globalTsgId, ...rest }} />
      </div>
    </Container>
  )
}

EnterpriseActivation.propTypes = {}

EnterpriseActivation.defaultProps = {
  licenses: [],
  licenseDispatch: noop,
  licenseContext: '',
  licenseHash: '',
  apps: {},
  globalDispatch: noop,
  licenseInstances: [],
}

export default EnterpriseActivation
